import * as React from "react";
import * as ReactDOM from "react-dom";

export class HeaderSeparator extends React.Component
{
    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        return <div className="header_separator"></div>;
    }
}